/**
 * Компонент для связывания Telegram аккаунта с существующим
 */

import React, { useState } from 'react';
import { linkTelegramAccount } from '../api';

interface AccountLinkingProps {
  telegramData: any;
  currentUser: any;
  onSuccess: (user: any) => void;
  onCancel: () => void;
}

const AccountLinking: React.FC<AccountLinkingProps> = ({
  telegramData,
  currentUser,
  onSuccess,
  onCancel
}) => {
  const [isLinking, setIsLinking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLinkAccount = async () => {
    setIsLinking(true);
    setError(null);

    try {
      const response = await linkTelegramAccount(telegramData, currentUser.id);
      
      if (response.success) {
        onSuccess(response.user);
      } else {
        setError(response.message || 'Failed to link accounts');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setIsLinking(false);
    }
  };

  return (
    <div className="account-linking-modal">
      <div className="modal-backdrop show"></div>
      <div className="modal show d-block" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-link-45deg me-2"></i>
                Связать аккаунты
              </h5>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-body text-center">
                      <i className="bi bi-person-circle text-primary" style={{ fontSize: '3rem' }}></i>
                      <h6 className="card-title mt-2">Текущий аккаунт</h6>
                      <p className="card-text small text-muted">
                        {currentUser?.email || 'Email не указан'}
                      </p>
                      <p className="card-text small">
                        {currentUser?.display_name || 'Имя не указано'}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-body text-center">
                      <i className="bi bi-telegram text-info" style={{ fontSize: '3rem' }}></i>
                      <h6 className="card-title mt-2">Telegram</h6>
                      <p className="card-text small text-muted">
                        @{telegramData.username || 'telegram_user'}
                      </p>
                      <p className="card-text small">
                        {telegramData.first_name} {telegramData.last_name || ''}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-3">
                <p className="text-center text-muted">
                  Связать Telegram аккаунт с вашим существующим аккаунтом? 
                  После этого вы сможете входить любым способом.
                </p>
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onCancel}
                disabled={isLinking}
              >
                Отмена
              </button>
              <button 
                type="button" 
                className="btn btn-primary" 
                onClick={handleLinkAccount}
                disabled={isLinking}
              >
                {isLinking ? (
                  <>
                    <div className="spinner-border spinner-border-sm me-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Связываем...
                  </>
                ) : (
                  <>
                    <i className="bi bi-link-45deg me-2"></i>
                    Связать аккаунты
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountLinking;
